import i18next from '../../../i18n';
import { Species } from '../../types/gql-op-types';
import {
  getNanoReferralPetAgeCookie,
  getNanoReferralPetBreedCookie,
  getNanoReferralPetGenderCookie,
  getNanoReferralPetNameCookie,
  getNanoReferralPetWeightCookie,
} from './nanoReferralPetNameCookie';

/**
 * Readers for the pet personalization url params (?pet_name=, ?pet_gender=, ...) that the nano,
 * quiz and rescue flows share. Moved here verbatim from NanoBanner.tsx, which re-exports them:
 * that component drags gsap into any importer, which jest cannot parse, and the readers have no
 * business depending on an animation library.
 */

export function getNanoVariantPetName(species: Species = Species.DOG) {
  let petName = new URLSearchParams(window.location.search).get('pet_name');
  if (!petName || petName.length > 10) {
    petName =
      species === Species.DOG
        ? i18next.t('your_dog')
        : species === Species.CAT
          ? i18next.t('your_cat')
          : i18next.t('your_pet');
  }
  return petName || getNanoReferralPetNameCookie();
}

/**
 * True when ?pet_name= carries a usable name - the same validity rule getNanoVariantPetName
 * applies before falling back to the generic your-dog strings. Callers that should only
 * personalize for a real name check this instead of comparing against localized fallbacks.
 */
export function hasNanoVariantPetName() {
  const petName = new URLSearchParams(window.location.search).get('pet_name');
  return !!petName && petName.length <= 10;
}

export function getNanoVariantPetAgeMonths() {
  return Number(new URLSearchParams(window.location.search).get('pet_age') || getNanoReferralPetAgeCookie());
}

export function getNanoVariantPetGender() {
  return new URLSearchParams(window.location.search).get('pet_gender') || getNanoReferralPetGenderCookie();
}

/** The gender param coerced to an ICU select argument; anything unrecognized selects `other`. */
export function getNanoVariantPetGenderSelect(): 'female' | 'male' | 'other' {
  const gender = getNanoVariantPetGender();
  return gender === 'female' || gender === 'male' ? gender : 'other';
}

export function getNanoVariantPetBreed() {
  return new URLSearchParams(window.location.search).get('pet_breed') || getNanoReferralPetBreedCookie();
}

export function getNanoVariantPetWeight() {
  return new URLSearchParams(window.location.search).get('pet_weight') || getNanoReferralPetWeightCookie();
}
